import { FunctionComponent } from 'react';
import { ViewProps } from './types';
import { Paragraph } from './styles';

/**
 * A paragraph represents a block of text and can appear as often as you like.
 */
const View: FunctionComponent<ViewProps> = (props) => (
  <Paragraph className="Paragraph" {...props} />
);

export default View;
